import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../utils/utils';

export default () => {
  const { TextWeight, isArabic } = dynamicfunction();
  const navigate = useNavigate()
  const { authContent } = useSelector((state) => state.content);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      authContent?.web_corporate_client_credential?.data?.attributes,
      key,
      isArabic,
    );
  };

  return {
    TextWeight,
    getContentKey,
    isArabic,
    navigate,
  };
};
